import React from "react";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import ISOLogo from "../../../images/iso.png";
import PCILogo from "../../../images/pci-dss.png";
import SecureLogo from "../../../images/home-page/trust-logo_1x.png";
import "./TrustWidget.css";

const TrustWidget = () => {
    return (
        <WidgetContainer>
            <div
                className="trust-widget"
                title="PhonePe is 100% Secure - this is a background"
            >
                <div className="trust-widget__secureimg-container">
                    <img
                        src={SecureLogo}
                        alt="PhonePe Trust Logo - 100% Secure"
                    />
                </div>
                <div className="trust-widget__container">
                    <h2>Your money stays safe.</h2>
                    <p>
                        PhonePe protects your money with the best-in-class
                        security systems that help minimize frauds.{" "}
                    </p>
                    <div className="trust-widget__logos">
                        <img src={PCILogo} />
                        <img src={ISOLogo} />
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default TrustWidget;
